import axios from 'axios'
import createAuthRefreshInterceptor from 'axios-auth-refresh'

const apiClient = axios.create({ baseURL: process.env.REACT_APP_API_DOMAIN })

console.log(process.env.REACT_APP_API_DOMAIN)

const refreshTokenStorage = JSON.parse(localStorage.getItem('refreshToken'))

const refreshAuthLogic = failedRequest => apiClient.post(`/auth/${refreshTokenStorage}/refresh`).then(tokenRefreshResponse => {
  sessionStorage.setItem('accessToken', JSON.stringify(tokenRefreshResponse.data.accessToken))
  failedRequest.response.config.headers['Authorization'] = 'Bearer ' + tokenRefreshResponse.data.accessToken
  return Promise.resolve()
}).catch(() => {
  sessionStorage.clear()
  window.location.reload()
})

createAuthRefreshInterceptor(apiClient, refreshAuthLogic)

export { apiClient }
